
export interface IPopiaConsentMessage {
    consent_link: string;
    consent_message: string;
    consent_title: string;
    deny_message: string;
}

export interface IPopiaConsentFeedback {
    consent_given: boolean;
    consent_message: string;
}

